export default function NoResult({ text }: Readonly<{ text?: string }>) {
    return (
        <div className="p-4 text-xl italic text-gray-500">
            <p>{text ?? 'Nessun risultato'}</p>
        </div>
    )
}
